module.exports = __webpack_public_path__ + "static/media/warning-icon.29f751cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/warning-icon.svg
// module id = 858
// module chunks = 0